import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-format-indent-decrease",
  templateUrl: "./med-icon-format-indent-decrease.component.html",
})
export class MedIconFormatIndentDecreaseComponent extends SvgMixinComponent {}
